import { Consts } from "vars";
/** Is Prod and meets minimum version. */
export const isProdFrom = (version) => Consts.isProd && isAtLeastVersion(version);
/** Is Prod and meets minimum version, or is Dev. */
export const isFrom = (version, extra) => Consts.isDev || isProdFrom(version) || ((extra === null || extra === void 0 ? void 0 : extra.beta) == true && Consts.isBeta);
var Flags;
(function (Flags) {
    /** Enable Physics v2 */
    Flags.isElectricalSymbolsEnabled = Consts.isDev;
    /** Labelling */
    Flags.isLabellingEnabled = Consts.isDev;
    Flags.isShapeSnappingEnabled = Consts.isDev;
    Flags.isSharingEnabled = true;
    /// New pricing.
    Flags.is2025PricingEnabled = true;
    /// Features on ice.
    Flags.isNewTemplatesEnabled = Consts.isDev || Consts.isBeta;
    /** Freehand tool. */
    Flags.isFreeHandToolEnabled = Consts.isDev;
    /** Watermark on exported images. */
    Flags.isExportWatermarkEnabled = Consts.isDev;
})(Flags || (Flags = {}));
/** Returns true if the current version is at least this version. */
function isAtLeastVersion(minVersion) {
    const current = parseVersion(Consts.version);
    const min = parseVersion(minVersion);
    return current[0] > min[0] || (current[0] == min[0] && current[1] >= min[1]);
}
/** Parses verion as major.minor. */
function parseVersion(versionAsString) {
    const matches = versionAsString.match("([0-9]*)\.([0-9]*)");
    return [+matches[1], +matches[2]];
}
export function currentDateBetween(after, before) {
    const now = new Date().getTime();
    const afterDate = Date.parse(after);
    const beforeDate = Date.parse(before);
    return now > afterDate && now < beforeDate;
}
// @ts-ignore unused
function currentDateAfter(date) {
    const now = new Date().getTime();
    return now > Date.parse(date);
}
export default Flags;
